import { jsx as r } from "react/jsx-runtime";
import { lazy as s, useEffect as e } from "react";
import { ErrorBoundary as c } from "react-error-boundary";
import { I18nextProvider as l } from "react-i18next";
import { LoadingEnum as g, I18nService as E } from "@perxis-auto/shared";
import { useStages as v } from "@perxis-auto/trade-in-sdk";
import { Provider as A } from "@perxis-auto/ui-kit/lib/components/Provider";
import P from "../shared/assets/locales/en/translation.json.js";
import S from "../shared/assets/locales/ru/translation.json.js";
import h from "../shared/assets/locales/uz/translation.json.js";
import { APP as t } from "../shared/config/app.js";
import { APP_EVENTS as I } from "../shared/config/events.js";
import { useAppContext as R, LanguageEnum as o } from "../shared/lib/app/context/appContext.js";
import { eventService as x } from "../shared/lib/event/eventService.js";
import { AppLayout as y } from "./layouts/AppLayout/AppLayout.js";
import { SuspenseLayout as z } from "./layouts/SuspenseLayout/SuspenseLayout.js";
import { AppProvider as B } from "./providers/AppProvider/AppProvider.js";
import { AppRouter as L } from "./router/AppRouter/AppRouter.js";
import "../shared/assets/styles/main.scss.js";
/* empty css         */
const T = s(() => import("../pages/ErrorStage/index.js")), b = ({ onSuccess: n, onFailure: i, onReset: m }) => {
  const { setAppHandlers: p, language: u = o.Ru } = R(), {
    actions: { getStages: d },
    loading: a
  } = v();
  e(() => {
    a === g.Idle && d();
  }, [a]), e(() => {
    p({
      onSuccess: n,
      onFailure: i,
      onReset: m
    });
  }, [i, m, n, p]), e(() => {
    x.sendEvent(I.Initialized);
  }, []);
  const f = E.getInstance({ language: u }).i18n.addResourceBundle(o.En, t.name, P, !0, !0).addResourceBundle(o.Ru, t.name, S, !0, !0).addResourceBundle(o.Uz, t.name, h, !0, !0);
  return /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(l, { i18n: f, children: /* @__PURE__ */ r(c, { fallback: /* @__PURE__ */ r(T, {}), children: /* @__PURE__ */ r(z, { children: /* @__PURE__ */ r(y, { children: /* @__PURE__ */ r(L, {}) }) }) }) }) });
};
b.Provider = B;
export {
  b as App
};
